import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearLocalSession } from 'Hooks/useLogout'
import { subscribeToAuthLogout } from 'Utils/authSessionSync'
import { ROUTES } from 'Utils/constants'

export default function AuthSessionSync() {
  const dispatch = useDispatch()
  const loginCode = useSelector(
    state => state.login?.user?.CustomerInfo?.LoginCode
  )
  const loginCodeRef = useRef(loginCode)

  useEffect(() => {
    loginCodeRef.current = loginCode
  }, [loginCode])

  useEffect(
    () =>
      subscribeToAuthLogout(() => {
        if (loginCodeRef.current !== 200) return

        loginCodeRef.current = null
        const isCustomerDisplayWindow =
          globalThis.location?.pathname?.startsWith(ROUTES.customerDisplay)

        clearLocalSession(dispatch, {
          redirectToLogin: !isCustomerDisplayWindow,
        })

        if (isCustomerDisplayWindow) {
          try {
            globalThis.close()
          } catch (error) {
            console.warn(
              'No se pudo cerrar Customer Display al finalizar la sesión:',
              error
            )
          }
        }
      }),
    [dispatch]
  )

  return null
}
